export default "__VITE_ASSET__CKHgoSBj__"